<template>
  <div class="profiles">
    <div class="container hero">
      <a href="https://giraffesoftware.com/" target="_blank">
        <img :src="hero" alt="hero" />
      </a>
    </div>
    <div class="container">
      <div class="mb-5 d-flex justify-content-between align-items-center">
        <h2 class="font-weight-bold mb-0">Available profiles</h2>
        <b-button
          class="button"
          variant="primary"
          @click="isFiltersVisible = !isFiltersVisible"
        >
          <span class="material-icons"> tune </span>
          Filters
        </b-button>
      </div>
      <div v-if="isFiltersVisible">
        <Filters
          ref="filter"
          class="profiles__filters"
          :data="filters"
          withGroups
          :isLoading="isLoading"
          @submit="onFilter"
          textButtonSubmit="Filter"
        />
      </div>
      <div class="profiles-wrapper">
        <ProfileWidgetItem
          v-for="(item, idx) in paginatedFilters"
          :key="idx + '-' + item.id"
          :user="item"
        />
      </div>
      <Preloader v-if="isLoading" />
      <div v-else-if="items.length === 0" class="text-center my-4">
        <h6>No people found. Please try to change filters settings.</h6>
      </div>
      <div
        v-if="items.length > maxItems"
        class="text-center mt-5"
      >
        <button @click="paginate">See more</button>
      </div>

      <div v-for="contactPerson in contactPersons" :key="contactPerson.name" class="mt-5 contact-block d-flex">
        <div class="contact-photo">
          <img :src="contactPerson.photo_url" />
        </div>
        <div class="contact-block__info">
          <h1 class="font-weight-bold mb-0">Contact person</h1>
          <div class="mt-3 contact-block__person">
            <h4>{{ contactPerson.name }}</h4>
            <h5 class="font-weight-light">{{ contactPerson.position }}</h5>
          </div>
          <div class="contact-block__items">
            <div v-if="contactPerson.skype">
              <div class="contact-item d-flex">
                <div class="contact-item__icon d-flex align-items-center">
                  <svg width="18" height="18">
                    <use xlink:href="../assets/icon-sprite.svg#skype"></use>
                  </svg>
                </div>
                <div class="contact-item__label">Skype</div>
              </div>
              <div class="contact-item__value">
                <a :href="`skype:${contactPerson.skype}?chat`">{{ contactPerson.skype }}</a>
              </div>
            </div>
            <div v-if="contactPerson.telegram">
              <div class="contact-item d-flex">
                <div class="contact-item__icon d-flex align-items-center">
                  <svg width="18" height="18">
                    <use xlink:href="../assets/icon-sprite.svg#telegram"></use>
                  </svg>
                </div>
                <div class="contact-item__label">Telegram</div>
              </div>
              <div class="contact-item__value">
                <a :href="`https://t.me/${contactPerson.telegram}`" target="_blank">@{{ contactPerson.telegram }}</a>
              </div>
            </div>
            <div v-if="contactPerson.email">
              <div class="contact-item d-flex">
                <div class="contact-item__icon d-flex align-items-center">
                  <svg width="18" height="18">
                    <use xlink:href="../assets/icon-sprite.svg#email"></use>
                  </svg>
                </div>
                <div class="contact-item__label">Email</div>
              </div>
              <div class="contact-item__value">
                <a :href="`mailto:${contactPerson.email}`">{{ contactPerson.email }}</a>
              </div>
            </div>
            <div v-if="contactPerson.mobile">
              <div class="contact-item d-flex">
                <div class="contact-item__icon d-flex align-items-center">
                  <svg width="18" height="18">
                    <use xlink:href="../assets/icon-sprite.svg#phone"></use>
                  </svg>
                </div>
                <div class="contact-item__label">Phone</div>
              </div>
              <div class="contact-item__value">
                <a :href="`tel:${contactPerson.mobile}`">{{ contactPerson.mobile }}</a>
              </div>
            </div>
            <div v-if="contactPerson.other">
              <div class="contact-item d-flex">
                <div class="contact-item__label">Other</div>
              </div>
              <div class="contact-item__value">{{ contactPerson.other }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileWidgetItem from '../components/ProfileWidgetItem.vue'
import Filters from '../components/Filter/Filter.vue'
import Preloader from '../components/Preloader'
import { mapGetters } from 'vuex'
import hero from '@/assets/gireffe-hero.png'

export default {
  components: {
    ProfileWidgetItem,
    Preloader,
    Filters
  },

  mounted () {
    this.fetchAllData()
  },

  data () {
    return {
      isFiltersVisible: false,
      isLoading: false,
      contactPersons: [],
      items: [],
      maxItems: 6,

      skills: [],
      skill: null,
      skill_value: '',
      roles: [],
      skillValueOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],

      filters: {
        groups: {
          availability: {
            fields: {
              skills: {
                type: 'multiselect',
                name: 'skills',
                label: 'Technologies',
                class: 'col-12 col-md-4 col-lg-2',
                valueField: 'id',
                selectLabel: 'name',
                options: [],
                value: [],
                group: 'availability'
              },
              years_of_experience: {
                type: 'range_slider',
                name: 'years_of_experience',
                label: 'Years of experience',
                value: ['1', '14'],
                data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'],
                class: 'col-12 col-sm-6 col-md-4 col-lg-2',
                group: 'availability'
              },
              seniority: {
                type: 'range_slider',
                name: 'seniority_lvl',
                label: 'Seniority level',
                valueField: 'id',
                labelField: 'name',
                value: [],
                data: [],
                class: 'col-12 col-sm-6 col-md-4 col-lg-2',
                group: 'availability'
              },
              availability: {
                type: 'multiselect',
                name: 'availability',
                label: 'Availability',
                valueField: 'id',
                selectLabel: 'name',
                value: [],
                class: 'col-12 col-sm-6 col-md-4 col-lg-2',
                options: [],
                group: 'availability',
                labelClass: 'text-lowercase'
              },
              allocation: {
                type: 'multiselect',
                name: 'allocation',
                label: 'Allocation',
                valueField: 'id',
                selectLabel: 'name',
                value: [],
                class: 'col-12 col-sm-6 col-md-4 col-lg-2',
                options: [],
                group: 'availability',
                labelClass: 'text-lowercase'
              }
            }
          }
        }
      },
      hero
    }
  },

  computed: {
    paginatedFilters () {
      return this.items.slice(0, this.maxItems)
    },
    ...mapGetters({
      getAllocations: 'users/getAllocations',
      getAvailability: 'users/getAvailability',
      getSeniorityLevels: 'users/getSeniorityLevels'
    })
  },

  methods: {
    paginate () {
      const newItemsCount = this.maxItems + 3
      this.maxItems =
        this.items.length > newItemsCount ? newItemsCount : this.items.length
    },

    async fetchAllocations () {
      return this.$api.users.getAllocations()
    },

    async fetchAvailability () {
      return this.$api.users.getAvailability()
    },

    async fetchSeniorityLevels () {
      return this.$api.users.getSeniorityLevels()
    },

    async fetchProfiles (formData = {}) {
      this.isLoading = true
      try {
        // this.maxItems = 6 TODO check
        // this.items = data TODO check
        const { data } = await this.axios.post('/api/user-profiles/search', { ...formData })

        this.items = data && data.data ? data.data : []
      } catch (err) {
        const errors = Object.values(err.response.data.errors)
        for (let i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      } finally {
        this.isLoading = false
      }
    },

    async fetchContactPersons () {
      this.isLoading = true
      try {
        const { data } = await this.axios.get('/api/contact-persons/search')

        this.contactPersons = data && data.data ? data.data : []
      } catch (err) {
        const errors = Object.values(err.response.data.errors)
        for (let i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      } finally {
        this.isLoading = false
      }
    },

    async fetchSkills () {
      try {
        const { data } = await this.axios({
          method: 'get',
          url: '/api/skills'
        })

        this.filters.groups.availability.fields.skills.options = data
      } catch (err) {
        const errors = Object.values(err.response.data.errors)
        for (let i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      }
    },

    fetchAllData () {
      return Promise.all([
        this.fetchAllocations(),
        this.fetchAvailability(),
        this.fetchSeniorityLevels(),
        this.fetchSkills(),
        this.fetchProfiles(),
        this.fetchContactPersons()
      ]).then(() => {
        this.setAllOptions()
      })
    },

    setAllOptions () {
      this.filters.groups.availability.fields.seniority.data = this.getSeniorityLevels
      this.filters.groups.availability.fields.seniority.value = [this.getSeniorityLevels[0], this.getSeniorityLevels[this.getSeniorityLevels.length - 1]]

      this.filters.groups.availability.fields.availability.options = this.getAvailability
      this.filters.groups.availability.fields.allocation.options = this.getAllocations
    },

    onFilter (data) {
      const dateForRequest = this.prepareDataForGetUsers(data)
      this.fetchProfiles(dateForRequest)
    },

    getElementsBetweenLabels (startLabel, endLabel, arr) {
      let startIndex, endIndex
      const resultArr = []

      // Find the index of the initial element
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].label === startLabel) {
          startIndex = i
          break
        }
      }

      // Looking for the index of a finite element
      for (let i = startIndex + 1; i < arr.length; i++) {
        if (arr[i].label === endLabel) {
          endIndex = i
          break
        }
      }

      // add elements to the result, starting from the element after the initial one and up to the final one
      for (let i = startIndex + 1; i < endIndex; i++) {
        resultArr.push(arr[i])
      }

      return resultArr
    },

    prepareDataForGetUsers (values) {
      let data = {}

      for (let groupKey in values.groups) {
        let groupFields = values.groups[groupKey].fields
        for (let key in groupFields) {
          const name = groupFields[key]['name']
          let value = groupFields[key]['value']

          if (Object.prototype.toString.call(value) === '[object Date]') {
            value = this._toLocalTime(value)
          }

          if (Array.isArray(value)) {
            value = value.map((t) => t[groupFields[key].valueField] || t)
          }

          data[name] = value
        }
      }

      return data
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  background-color: #3fa52f;
  border: none;
  color: white;
  padding: 0.7rem 2.5rem;
  font-size: 1.1rem;
  border-radius: 2rem;

  &:hover {
    background-color: #218838;
  }
}

.contact-block {
  background-color: white;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  border-radius: 1rem;
  padding: 1.5rem 2rem;
  gap: 40px;

  img {
    width: 255px;
    height: 255px;
    object-fit: cover;
    border-radius: 1.5rem;
  }

  &__info {
    flex: 1;
    h1, h4, h5 {
      font-weight:bold;
    }
  }

  &__person {
    color: #3D5170;

    h4 {
      color: #0052CC;
    }
  }

  &__items {
    > div {
     width: 50%;
    }
    margin-top: 30px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 20px;
    column-gap: 30px;
  }
}

.contact-item {
  &__icon {
    margin-right: 10px;

    svg {
      color: #3D5170;
    }
  }

  &__label {
    font-weight: 700;
    color: #3D5170;
  }
}

@media all and (max-width: 1200px) {
  .contact-block {
    &__items {
      display: flex;
      flex-flow: row wrap;
      > div {
        flex: 1 auto;
        width: 100%;
      }
    }
  }
}

@media all and (max-width: 767px) {
  .contact-block {
    padding: 1.5rem;
    display: flex;
    flex-flow: row wrap;
    > * { flex: 1 auto; }
    &__items {
      display: flex;
      flex-flow: row wrap;
      > * { flex: 1 auto; }
    }
  }
  .contact-photo img {
    max-width: 255px;
    max-height: 255px;
    width: 100%;
    height: 100%;
  }
  .contact-block {
    &__info {
      h1 { font-size: 30px; }
      h4 { font-size: 20px; }
      h5 { font-size: 15px; }
    }
  }

  .contact-item {
    &__label {
      font-size: 15px;
    }
    &__value {
      font-size: 13px;
    }
  }
}

.profiles {
  background: #f4f5f7;
  min-height: 100vh;
  padding-bottom: 5rem;

  &__filters {
    background-color: white;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    border-radius: 1rem;
    padding: 1.5rem 2rem;
  }

  &-wrapper {
    display: flex;
    flex-direction: column;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 28px;

    @media (min-width: 768px) {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (min-width: 992px) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
}

.hero {
  padding-bottom: 2rem;
  img {
    width: 100%;
    object-fit: cover;
  }
}

.icon {
  color: #0052CC;
}
</style>
